import { useEffect, useState } from 'react'
import { getDefaultWorkspace } from '../api/client'

let cachedId: string | null = null
let inflight: Promise<string> | null = null

async function resolveWorkspaceId(): Promise<string> {
  if (cachedId) return cachedId
  if (!inflight) {
    inflight = getDefaultWorkspace().then(({ data }) => {
      cachedId = data.id
      return data.id
    })
  }
  return inflight
}

/**
 * The app is scoped to a single implicit workspace per machine/install.
 * There is no workspace-switcher UI; this hook just resolves the one
 * workspace id the backend auto-provisions, for internal API calls.
 */
export function useDefaultWorkspace() {
  const [workspaceId, setWorkspaceId] = useState<string | null>(cachedId)

  useEffect(() => {
    if (cachedId) {
      setWorkspaceId(cachedId)
      return
    }
    resolveWorkspaceId().then(setWorkspaceId)
  }, [])

  return workspaceId
}

export { resolveWorkspaceId }
